import * as action_types from '../actions/action_types';
import { console_log } from "../utils/helper";

const initialState = {
    domain: []
};

export const DomainReducer = (state = initialState, action = {}) => {
    switch (action.type) {
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/reducers/DomainReducer.js